import React, { Component } from 'react'
import ReactTable from 'react-table';
import { getCategoriesV2List } from '../../modules/Api';
import history from '../../modules/History';
import { btnStyle, getSliderRouteParams } from './common';
import ACL from '../../components/ACL';

class Categories extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }
    componentDidMount() {
        const filter = {
            parent_id: 1,
        }

        this.fetchData('filter='+JSON.stringify(filter));
    }
    fetchData = (query = '') => {
        getCategoriesV2List(query, (data) => {this.setState({
            items: data.data,
            last_page: data.last_page,
            count: data.total,
            pageSize: data.per_page
        })});
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
            },
            {
                Header: 'عنوان',
                Cell: row => (<span title={row.original.name}> {row.original.name} </span>)
            },
            {
                Header: 'ویرایش',
                accessor: 'edit',
                Cell: (row) => <ACL component="span" has_permission="categories_management|categories_edit"><span style={{...btnStyle, backgroundColor: '#0066ff'}} onClick={() => {window.open(`/categories/edit/${row.original.id}`, "_blank")}}>ویرایش</span></ACL>,
                style:{textAlign:'center'}
            },
            {
                Header: 'زیر‌دسته‌ها',
                accessor: 'subcategories',
                Cell: (row) => <span style={{...btnStyle, backgroundColor: '#b4004e'}} onClick={() => {window.open(`/categories/${row.original.id}`, "_blank")}}>زیردسته‌ها</span>,
                style:{textAlign:'center'}
            },
            {
                Header: 'اسلایدر',
                accessor: 'sliders',
                style:{textAlign:'center'},
                Cell: (row) =>
                    <React.Fragment>
                        <ACL component="span" has_permission="sliders_management|sliders_list"><span style={{...btnStyle, backgroundColor: '#066'}} onClick={() => {history.item.push(getSliderRouteParams(row))}}>سایت</span></ACL>
                        <ACL component="span" has_permission="application_sliders_management|application_sliders_list"><span style={{...btnStyle, backgroundColor: '#606'}} onClick={() => {history.item.push(getSliderRouteParams(row, true))}}>اپ</span></ACL>
                    </React.Fragment>
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    // onFetchData={state => this.onChange(state)}
                    defaultPageSize={this.state.pageSize}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default Categories;


// WEBPACK FOOTER //
// ./src/containers/Categories/index.js